import { useGet } from 'lib/api';
import { checkModule } from '../utils';
import type { LoggedInUser } from '../types';
import { apiUsers } from 'api/users';

export const useModule = (module: string) => {
  const { data } = useGet<LoggedInUser>(apiUsers.get.loggedInUser, 'logged-in-user');
  const hasAccess = checkModule(module, data?.Organization?.Modules);
  return hasAccess;
};
